import React, { useState } from "react";
import { useParams } from "react-router-dom";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ProductDetailsBanner from "./ProductDetailsBanner";
import ProductDetailsSingle from "./ProductDetailsSingle";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const ProductDetails = () => {
  const [loading, setLoading] = useState(true);

  const [projectName, setProjectName] = useState('');
  

  const handleProjectName = (name) => {
    setProjectName(name);
  };
  const { id } = useParams();
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <ProductDetailsBanner projectName={projectName} />
      <ProductDetailsSingle id={id} onProjectName={handleProjectName} />
      <FooterThree />
    </div>
  );
};

export default ProductDetails;
